import { render, staticRenderFns } from "./Trait.vue?vue&type=template&id=afd0fea0"
import script from "./Trait.vue?vue&type=script&lang=js"
export * from "./Trait.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports